@if (!projectConsolidatedReport) {
  @for (site of sites; track site) {
    <div>
      @if (!isSingleReport) {
        <div class="mat-body-2">SITE {{site.name}}</div>
      }
      <div class="cards-container">
        @if (!isSingleReport && !site.summary.length) {
          <div>No records</div>
        }
        @for (summary of site.summary; track summary) {
          <div class="card">
            <!-- BidItem view -->
            <div class="mat-subtitle-1">{{summary.biditem.item}}</div>
            <div class="mat-body">{{summary.biditem.description}}</div>
            <div class="mat-caption">UOM: {{summary.biditem.uom}}</div>
            <!-- /BidItem view -->
            <div class="line-items">
              @if (!summary.headings) {
                <ng-container [ngTemplateOutlet]="LineItem"
                [ngTemplateOutletContext]="{ 'biditem': summary.biditem, 'lineItems': summary.lineItems }"></ng-container>
              }
              @if (summary.headings) {
                <ng-container [ngTemplateOutlet]="HeadingItem"
                [ngTemplateOutletContext]="{ 'biditem': summary.biditem, 'headings': summary.headings }"></ng-container>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
}

@if (projectConsolidatedReport) {
  @for (bi of usedBidItems; track bi) {
    <div>
      <div class="mat-body-2">
        <span>{{bi.item}} {{bi.description}}</span>
        <br /><br />
        <span class="total">TOTAL: {{bi.totalQuantity}}</span>
      </div>
      <div class="cards-container">
        @if (!bi.summary.length) {
          <div>No records</div>
        }
        @for (summary of bi.summary; track summary) {
          <div class="card">
            <!-- site view -->
            <!-- <div class="mat-subheading-2">{{summary.biditem.item}}</div> -->
            <div class="mat-body">{{summary.site.name}}</div>
            <div class="mat-caption">UOM: {{bi.uom}}</div>
            <!-- /site  view -->
            <div class="line-items">
              @if (!summary.headings) {
                <ng-container [ngTemplateOutlet]="LineItem"
                [ngTemplateOutletContext]="{ 'biditem': bi, 'lineItems': summary.lineItems }"></ng-container>
              }
              @if (summary.headings) {
                <ng-container [ngTemplateOutlet]="HeadingItem"
                [ngTemplateOutletContext]="{ 'biditem': bi, 'headings': summary.headings }"></ng-container>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
}


<ng-template #LineItem let-biditem="biditem" let-lineItems="lineItems">
  @for (li of lineItems; track li) {
    <div class="row link" (click)="openRBI(li)">
      <img [src]="getPreviewUrl(null, lineItems)" alt="Thumb image" />
      <div>
        <div>QTY: {{li?.quantity || li?.calculatedQuantity}}</div>
        @if (li.comment) {
          <div>Comment: {{li.comment}}</div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #HeadingItem let-biditem="biditem" let-headings="headings">
  @for (h of headings; track h) {
    <div class="row link" (click)="openRBI(h.header)">
      <img [src]="getPreviewUrl(h.header, h.lineItems)" alt="Thumb image" />
      <div>
        <div>QTY
          @if (getUom(biditem)) {
            ({{getUom(biditem)}})
            }:
            @if (biditem?.rollup_field) {
              {{h.rollUp}}
            }
            @if (!biditem?.rollup_field) {
              {{h.header?.quantity}}
            }
          </div>
          <div>{{h.heading?.name}}</div>
        </div>
      </div>
    }
  </ng-template>
